<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">线路站台管理</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="线路名称">
            <el-select v-model="LineId" placeholder="请选择">
              <el-option
                v-for="item in LineArr"
                :key="item.ID"
                :label="item.LineName"
                :value="item.ID"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="站台名称">
            <el-select v-model="StationId" placeholder="请选择">
              <el-option
                v-for="item in StationArr"
                :key="item.Id"
                :label="item.StationName"
                :value="item.Id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="线路方向">
            <el-select v-model="Direction" placeholder="请选择">
              <el-option
                v-for="item in DirectionArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="LineName"
                label="线路名称"
              ></el-table-column>
              <el-table-column
                prop="StationName"
                label="站台名称"
              ></el-table-column>
              <el-table-column prop="Direction" label="方向"></el-table-column>
              <el-table-column
                prop="StationIndex"
                label="站点序号"
              ></el-table-column>
              <el-table-column prop="Description" label="备注">
                <template slot-scope="scope">
                  <el-popover
                    placement="top-start"
                    title="备注"
                    width="250"
                    trigger="hover"
                  >
                    <div>{{ scope.row.Description }}</div>
                    <span slot="reference">{{
                      scope.row.Description != null &&
                      scope.row.Description.length > 15
                        ? scope.row.Description.substr(0, 15) + "..."
                        : scope.row.Description
                    }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="queryDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >查看</el-button
                    >
                    <el-button
                      @click="editDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >编辑</el-button
                    >
                    <el-button
                      @click="deleteClick(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >删除</el-button
                    >
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";
export default {
  name: "LineStationManagerView",
  controller: "UI",
  action: "LineStationManagerView",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      LineId: "",
      LineArr: [],
      StationId: "",
      StationArr: [],
      Direction: "",
      DirectionArr: [
        { value: "单行", label: "单行" },
        { value: "上行", label: "上行" },
        { value: "下行", label: "下行" },
      ],
    };
  },
  created: function() {
    this.getLines();
    this.getStations();
  },
  mounted: function() {
    this.search();
    this.logInfo.ActionName = "线路站台管理查询";
    this.logInfo.LogMessage = "线路站台管理查询";
    this.logInfo.ModuleName = "车辆调度";
    this.logInfo.PageName = "线路站台管理列表";
    this.addOperationLog();
  },
  methods: {
    search() {
      let searchInfo = {
        LineId: this.LineId,
        StationId: this.StationId,
        Direction: this.Direction,
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };
      new MyApis.LineStationRelationApi()
        .GetItemPagingList(searchInfo)
        .then((r) => {
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //绑定线路类型
    getLines() {
      const SearchInfo = {
        Validity: "1",
      };
      new MyApis.LinesApi()
        .GetItemPagingList(SearchInfo)
        .then((r) => {
          r = r.data.Data;
          this.LineArr = r.PageContents;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //绑定站台类型
    getStations() {
      const SearchInfo = {
        Validity: "1",
      };
      new MyApis.StationsApi()
        .GetItemPagingList(SearchInfo)
        .then((r) => {
          r = r.data.Data;
          this.StationArr = r.PageContents;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/vehicleScheduling/UI/LineStationManagerInfo",
        query: {
          type: "add",
        },
      });
    },
    //查看
    queryDetail(index, row) {
      this.$router.push({
        path: "/plugin/vehicleScheduling/ui/LineStationManagerInfo",
        query: { InfoId: row.ID, type: "query" },
      });
    },
    //编辑
    editDetail(index, row) {
      this.$router.push({
        path: "/plugin/vehicleScheduling/ui/LineStationManagerInfo",
        query: { InfoId: row.ID, type: "edit" },
      });
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          new MyApis.LineStationRelationApi()
            .DelItem(row)
            .then((r) => {
              r = r.data.Data;
              if (r) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.logInfo.ActionName = "线路站台删除";
                this.logInfo.LogMessage = "线路站台删除成功";
                this.logInfo.ModuleName = "车辆调度";
                this.logInfo.PageName = "线路站台管理列表";
                this.addOperationLog();
              } else {
                this.$message({
                  type: "error",
                  message: "删除失败!",
                });
              }
              this.search();
            })
            .catch((e) => {
              console.log(e);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.LineId = "";
      this.StationId = "";
      this.StationName = "";
      this.Direction = "";
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
  },
};
</script>
